import { Link } from "react-router-dom";

export default function DashboardSidebar() {
    return (
        <aside className="w-64 bg-white border-r shadow-sm">
            <div className="p-5 font-bold text-xl border-b text-red-600">
                Admin Panel
            </div>

            <nav className="p-4 space-y-3">
                <Link to="/dashboard/articles"
                    className="block px-4 py-2 rounded hover:bg-red-50 text-gray-700">
                    📄 Articles
                </Link>

                <Link to="/dashboard/articles/create"
                    className="block px-4 py-2 rounded hover:bg-red-50 text-gray-700">
                    ✍️ Create Article
                </Link>
            </nav>
        </aside>
    );
}
